export function startGameFromMenu() {
	const splash = document.getElementById('splash')
	const playButton = document.getElementById('play-button')
	const startGame = () => {
		if (splash) {
			splash.classList.add('starting')
			setTimeout(() => {
				splash.remove()
			}, 420)
			document.body.removeEventListener('keydown', handleKeyDown)
		}
	}

	const handleKeyDown = (e: KeyboardEvent) => {
		if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
			e.preventDefault()
			e.stopImmediatePropagation()
			e.stopPropagation()
		} else if (e.key === ' ' || e.key === 'Enter' || e.key === 'Spacebar') {
			startGame()
		}
	}

	if (splash && playButton) {
		document.body.addEventListener('keydown', handleKeyDown)
		playButton.addEventListener('click', startGame)
	}
}
